export class WindAndBrightnessThresholds {
    constructor() {
        this.WindThreshold = WindThresholdStep.Disabled;
        this.BrightnessThreshold = BrightnessThresholdStep.Disabled;
    }
}
export var WindThresholdStep;
(function (WindThresholdStep) {
    WindThresholdStep[WindThresholdStep["Disabled"] = 0] = "Disabled";
    WindThresholdStep[WindThresholdStep["Speed15km_h"] = 1] = "Speed15km_h";
    WindThresholdStep[WindThresholdStep["Speed21km_h"] = 2] = "Speed21km_h";
    WindThresholdStep[WindThresholdStep["Speed28km_h"] = 3] = "Speed28km_h";
    WindThresholdStep[WindThresholdStep["Speed36km_h"] = 4] = "Speed36km_h";
    WindThresholdStep[WindThresholdStep["Speed45km_h"] = 5] = "Speed45km_h";
    WindThresholdStep[WindThresholdStep["Speed55km_h"] = 6] = "Speed55km_h";
    WindThresholdStep[WindThresholdStep["Speed66km_h"] = 7] = "Speed66km_h";
    WindThresholdStep[WindThresholdStep["Speed78km_h"] = 8] = "Speed78km_h";
    WindThresholdStep[WindThresholdStep["Speed91km_h"] = 9] = "Speed91km_h";
})(WindThresholdStep || (WindThresholdStep = {}));
export var BrightnessThresholdStep;
(function (BrightnessThresholdStep) {
    BrightnessThresholdStep[BrightnessThresholdStep["Disabled"] = 0] = "Disabled";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness2000lux"] = 1] = "Brightness2000lux";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness5000lux"] = 2] = "Brightness5000lux";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness10000lux"] = 3] = "Brightness10000lux";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness20000lux"] = 4] = "Brightness20000lux";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness40000lux"] = 5] = "Brightness40000lux";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness60000lux"] = 6] = "Brightness60000lux";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness70000lux"] = 7] = "Brightness70000lux";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness80000lux"] = 8] = "Brightness80000lux";
    BrightnessThresholdStep[BrightnessThresholdStep["Brightness90000lux"] = 9] = "Brightness90000lux";
})(BrightnessThresholdStep || (BrightnessThresholdStep = {}));
//# sourceMappingURL=WszfBidiConfigParams.js.map